import { ComposableMap, Geographies, Geography, Marker } from 'react-simple-maps';
import '../styles/location.scss';

const geoUrl = 'https://saral-docs-prod.s3.amazonaws.com/world.json';

export default function AudienceLocationCityCard({ locationData }) {
  if (!locationData || locationData.length === 0) {
    return null;
  }

  const calculateOtherPercent = () => {
    let val = (locationData.slice(10, locationData.length).reduce((a, b) => a + b.weight, 0) * 100).toFixed(2);
    return val;
  };

  return (
    <div className="demographics-card">
      <h2>Audience Location by City</h2>
      {locationData && (
        <div className="location-div">
          <div className="map-container">
            <ComposableMap projection="geoMercator" projectionConfig={{ scale: 140 }} viewBox="0 0 800 460">
              <Geographies geography={geoUrl}>
                {({ geographies }) =>
                  geographies.map((geo) => {
                    return <Geography key={geo.rsmKey} geography={geo} fill="#e2e2e2" stroke="#fff" strokeWidth={1} />;
                  })
                }
              </Geographies>
              {locationData?.map((data) => (
                <Marker key={data.id} coordinates={[data.coords.lon, data.coords.lat]}>
                  <circle r={5} fill="#7357E9" stroke="#fff" strokeWidth={1} />
                </Marker>
              ))}
            </ComposableMap>
          </div>

          <div className="stats-container">
            {locationData?.slice(0, 10).map((loc) => (
              <div className="location-stats" key={loc.id}>
                <p>
                  <img
                    src={`https://flagcdn.com/16x12/${loc.country.code.toLowerCase()}.png`}
                    width="20"
                    height="15"
                    alt={loc.country.name}
                  />
                  {loc.name}
                </p>
                <span>{(loc.weight * 100).toFixed(2)}%</span>
              </div>
            ))}
            {locationData?.length > 10 && (
              <div className="location-stats">
                <p>Other</p>
                <span>{calculateOtherPercent()}%</span>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
